import { Map } from 'immutable';

import { updateListingScore } from '../../product/score';
import { replaceOperation } from '../../product/operations';
import { tagsFromArray } from '../../tags';
import { editTags } from '../tags';

import { ATTRIBUTE } from '../../../constants/attributes';
import { VALUE } from '../../../constants/product';
import { EMPTY } from '../../../constants';
import { FORM } from '../../../constants/forms';

export function tags({ operation, product, titleFormatPreference, ...rest }) {
  const updates = editTags({
    operation: operation.get('type'),
    product: product.set(FORM.TAGS, Map({ [VALUE]: tagsFromArray(operation.get('value')) })),
  });

  if (updates.product.hasIn(['score', ATTRIBUTE.TAGS])) {
    updates.product = updateListingScore(updates.product, { titleFormatPreference });
  }

  return {
    ...rest,
    product: updates.product = updates.product.set('operations',
      updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
    ),
  };
}
